<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row class="mx-auto pa-2" no-gutters >
        <v-col class="pa-2" cols="12">
          <v-progress-linear v-show="loading" height="5" indeterminate />
        </v-col>

        <v-col class="pa-2" cols="12" md="4" style="position: relative; min-height: 100%;">
        <div class="sticky-preview">
          <component
            :is="theme"
            v-model="data"
            :data="data"
            :orders.sync="orders"
            class="sticky-md"
            style="top: 110px"
          />
          </div>
        </v-col>

        <v-col class="pa-2" cols="12" md="8">
          <v-card :disabled="loading" flat>
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <div class="row">
                  <div class="col-md-12">
                    <p>{{ $t("enter_visit_card_pro_info") }}</p>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="res.title"
                        :error-messages="errors['title']"
                        append-icon="mdi-pen"
                        class="mt-0 pt-0 contentinfo"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        :label="$t('visit_card_name_pro')"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-Qr-res-title`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('visit_card_name_label')"
                      />
                    </div>
                  </div>
                </div>
              </v-stepper-step>
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                <list-expansion
                  flat
                  icon="pencil-ruler"
                  single
                  :title="$t('select_template_design')"
                  :data="data"
                >
                  <template v-slot:content>
                    <theme-selector v-model="theme" :components="customTheme" />
                  </template>
                </list-expansion>
                <list-expansion
                  v-model="data"
                  :components="specialInfo"
                  :data="data"
                />
                <qr-generator v-model="data" />

                <div class="col-md-12">
                  <next-btn :loading="loading" @click="markQr(true)" />
                </div>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="{ title: $t('download') }"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('download')"
            />
          </template>
        </custom-popup>
        <translate-language-loader-v-2 :color="'#D4AF37' || '#ff1d5e'" />
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import { Bus, debounce } from "@/main";
import MobileViwer from "@/view/pages/qrland/components/mobileViwer";
import QrGenerator from "@/view/pages/qrland/components/qrGenerator";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import TextCards from "@/view/pages/qrland/components/textCards";
import ListExpansion from "@/view/content/fragments/listExpansion";
import PrevBtn from "@/view/content/fragments/prevBtn";
import NextBtn from "@/view/content/fragments/nextBtn";
import ThemeSelector from "@/view/pages/qrland/components/themes/themeSelector";
import VisitThemeTwo from "@/view/pages/qrland/components/themes/visitThemeTwo";
import VisitThemeFlipped from "@/view/pages/qrland/components/themes/visitThemeFlipped";
import { mapActions, mapGetters } from "vuex";
import { getLanguageCookie } from "../../../core/plugins/TitleRibbon/utils/languageCookie";
import TranslateLanguageLoaderV2 from "../otherQrTypes/luckWheel/TranslateLanguageLoaderV2.vue";
import { setDragging } from "@/utilities/DraggingKeysOrder";
import transitions from "vuetify/lib/components/transitions";

export default {
  name: "editVisitProModel",
  components: {
    ThemeSelector,
    PrevBtn,
    NextBtn,
    ListExpansion,
    TextCards,
    QrManagement,
    QrCustomize,
    QrGenerator,
    MobileViwer,
    VisitThemeTwo,
    VisitThemeFlipped,
    TranslateLanguageLoaderV2,
  },
  props:{
    id:{type:String, default:''},
  },
  data() {
    return {
      currentEditingLang: "fa",
      serviceName: "Qrland",
      componentName: "editVisit",
      helpData: [],
      showDialog: false,
      data: {},
      errors: {},
      finish: false,
      loading: false,
      e6: 1,
      qrLink: "",
      security: {},
      dtUrl: null,
      theme: "",
      orders: [],
      customTheme: [
        { name: "MobileViwer", value: "" },
        { name: "VisitThemeTwo", value: "" },
        { name: "VisitThemeFlipped", value: "" },
      ],
      res: {},
    };
  },

  watch: {
    data: {
      deep: true,
      handler(newVal) {
        debounce(() => {
          this.setKeys(newVal);
          //  this.syncToMobileViewer();
        }, 250);
      },
    },

    currentLang() {
      this.syncToMobileViewer();
    },
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    // theme(newTheme) {
    //   this.$root.$emit("visit-data-updated", {
    //     data: this.data,
    //     orders: this.orders,
    //     theme: newTheme,
    //     lang: this.currentLang,
    //   });
    // },
  },

  mounted() {
    this.$root.$on("mobile-viewer-updated", (payload) => {
      if (payload.lang === this.currentLang) return;

      if (payload?.orders) {
        this.orders = [...payload?.orders];
      }
      if (payload?.data) {
        this.data = { ...payload?.data };
      }
      if (payload?.theme) {
        this.theme = payload?.theme;
      }
    });
    this.$root.$on("language-changed", ({ lang }) => {
      if (this.currentLang === lang) return;
      this.currentLang = lang;
    });
    Bus.$on("colorPalette", (value) => {
      this.data.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.data.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      this.data.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.data.isGradient = value;
    });

    Bus.$on("audioType", (value) => {});

    this.$root.$on("qrUpdate", (payload) => {
      this.qrUpdate(false);
      //this.saveToLangFtp(this.currentEditingLang, false, payload);
    });
    this.fetchData();
    this.$nextTick(() => {
      this.setKeys(this.data);
      //  this.syncToMobileViewer();
    });
  },
  destroyed() {
    this.$root.$off("language-changed");
  },
  computed: {
    ...mapGetters("localstorage", [
      "createQrID",
      "alllangs",
      "defaultLang",
      "mainDatalang",
    ]),
    specialInfo() {
      return [
        // {
        //   name: "managmentLanguage",
        //   value: "",
        //   title: this.$t("language.management_langs"),
        //   subtitle: "",
        //   icon: "translate",
        //   model: "langs",
        //   mainData: this.data,
        // },
        {
          name: "textCards",
          value: "",
          title: this.$t("user_info"),
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "customerClubSettings",
          title: this.$t("sms_membership_message"),
          icon: "cellphone-message",
          model: "customerClub",
        },
        {
          name: "advanceSettings",
          title: this.$t("smart_settings"),
          icon: "star-settings-outline",
          model: "advanceSettings",
        },
        {
          name: "voiceGallery",
          title: this.$t("add_audio_file"),
          icon: "microphone",
          model: "audiosGallery",
        },
         {
          name: "pdfSelector",
          value: "",
          title: "گالری پی دی اف ",
          subtitle: "",
          icon: "file-outline",
        },
        {
          name: "FeedBack",
          value: "",
          title: "بازخورد",
          subtitle: "",
          icon: "reply-outline",
          model: "FeedBack",
        },
        {
          name: "consultationNew",
          value: "",
          title: "فرم درخواست",
          subtitle: "",
          icon: "list-box-outline",
          model: "consultationNew",
        },
      ];
    },
  
    domainName() {
      return this.$route.params?.name;
    },
    qrId() {
      return this.$route.params?.id;
    },
  },
  created() {
    this.$root.$on("editvisit-lang-change", (lang) => {
      this.currentEditingLang = lang;
    });

    this.$root.$on("lang-data-loaded", ({ lang, data }) => {
      this.currentLang = lang;
      this.data = data;
      this.orders = data?.orders || [];
      this.theme = data?.theme;
      this.$root.$emit("visit-data-updated", {
        data: {
          data: this.data,
          orders: this.orders,
          theme: this.theme,
          lang: this.currentLang,
        },
      });
      this.$forceUpdate();
    });

    this.$root.$on("lang-maindata-updated", (data) => {
      this.data = { ...data };
    });
    this.currentEditingLang = this.defaultLang;
  },
  methods: {
    ...mapActions("localstorage", [
      "setCreatedQrID",
      "setLangList",
      "setDefaultLang",
      "setMainData",
    ]),
    ...mapActions("local", [
      "updateQrInfo",
      "updateQridentifier",
      "updateQrDomain",
      "updateQrId",
    ]),
    onCancel() {
      this.goto('qr/list');
    },
    setKeys(val = this.cardTexts) {
      let keys = setDragging(val, this.orders);
      if (
        val.audiosGallery &&
        val.audiosGallery.audios &&
        val.audiosGallery.audios.length > 0
      ) {
        const audioKeys = val.audiosGallery.audios.map((_, index) => ({
          name: `audio_${index}`,
        }));
        keys = [
          ...keys.filter((key) => !key.name.startsWith("audio_")),
          ...audioKeys,
        ];
      }

      keys = keys.filter((item) => item.name !== "audiosGallery");

      keys = keys.filter(
        (item) => item.name !== "langs" && item.name !== "language",
      );

      this.orders = keys;
      this.$forceUpdate();
    },

    syncToMobileViewer() {
      this.$root.$emit("visit-data-updated", {
        data: {
          data: JSON.parse(JSON.stringify(this.data)),
          orders: [...this.orders],
          theme: this.theme,
          lang: this.currentLang,
        },
      });
    },
    // loadLangData(lang) {
    //   this.$api.get(`/langData?id=${this.qrId}&lang=${lang}`).then((res) => {
    //     const newData = res?.[0] || {};
    //     this.$root.$emit("visit-data-updated", {
    //       data: newData.data,
    //       orders: newData.orders || [],
    //       theme: newData.theme || "MobileViwer",
    //       lang: lang,
    //     });
    //   });
    // },
    

    fixVideoGallery(data) {
      let d = { ...data };

      if (!!d.video_single?.videos?.length) {
        if (!d.hasOwnProperty("video_gallery"))
          d.video_gallery = [
            {
              name: d.video_single.name || this.$t("video_gallery"),
              images: d.video_single.videos,
            },
          ];
        else
          d.video_gallery.push({
            name: d.video_single.name || this.$t("video_gallery"),
            images: d.video_single.videos,
          });
      } else if (!d.hasOwnProperty("video_gallery"))
        d.video_gallery = [
          {
            name: this.$t("video_gallery"),
            images: [],
          },
        ];
      if (!!d.video_single) delete d.video_single;
      return d;
    },
       fetchData() {
      this.loading = true;
      this.$api
        .get(`qr/template/${this.id}`)
        .then(({ data }) => {
          this.loading = false;
          
          let parsedData =
            typeof data.data.qr.data === "string"
              ? JSON.parse(data.data.qr.data)
              : data.data.qr.data;

          this.theme = parsedData.theme || "MobileViwer";
          let info = parsedData; 

          this.res = data.data;
          this.setCreatedQrID(data?.data?.id);
          this.updateQrInfo(data.data);
          this.updateQrId(data.data.id);

          this.setLangList(
            data?.data?.lang
              ?.split(",")
              ?.filter((l) => l !== data?.data?.default) || [],
          );
          this.setDefaultLang(data?.data?.default || "fa");
          
          if(info?.language)
            info.language = this.defaultLang || getLanguageCookie() || info?.language || "fa";
            
          this.currentEditingLang = info?.language;
          this.$root.$emit("mobile-viewer-lang-change", this.currentEditingLang);

          if (!!info?.data?.orders) {
            this.orders = info.data.orders;
          } else {
            this.orders = [
                { name: "userName" }, { name: "workField" }, { name: "aboutUs" },
                { name: "extraFields" }, { name: "video_gallery" }, { name: "photo" },
                { name: "FeedBack" }, { name : "consultation"}, { name: "phoneNumber" },
                { name: "fax" }, { name: "location" }, { name: "codePostal" },
                { name: "email" }, { name: "website" }, { name: "audio_0" },
            ];
          }

          try {
            if (info.data?.coordinates) info.data.coordinates.sort((a, b) => b - a);
            if (info.data?.center) info.data.center.sort((a, b) => b - a);
          } catch (e) {}

          if (info?.data?.photo) info.data.photo = { ...info.data.photo, hasGame: false, hasGif: false };
          if (!info?.data?.video_gallery) info.data.video_gallery = [{ name: "", images: [] }];
          if (!info?.data?.photo) info.data.photo = {};
          if (!info.data?.photo?.gallery) info.data.photo.gallery = [{ name: "", images: [] }];
          if (!info.data?.audiosGallery) info.data.audiosGallery = { audios: [], audioType: "newPlayer" };

          if (Array.isArray(info?.data?.audiosGallery)) {
            let audios = info.data.audiosGallery.length > 0 ? info.data.audiosGallery : [];
            audios = audios.map(audio => ({ ...audio, autoPlay: audio.autoPlay || false }));
            info.data.audiosGallery = { audios: audios, audioType: "newPlayer" };
          } else if (info.data?.audiosGallery?.audios) {
            info.data.audiosGallery.audios = info.data.audiosGallery.audios.map(audio => ({ ...audio, autoPlay: audio.autoPlay || false }));
          }

          info.data.language = this.defaultLang || getLanguageCookie() || info?.data?.language || "fa";
          info.data.langs = {
            source_lang: this.defaultLang || info?.data?.langs?.source_lang || "fa",
            other_langs: this.alllangs?.map((x) => ({ lang: x, status: "edited" })) || [],
          };
          
          if (!info.data.pdf) info.data.pdf = null;
          if (!info.data.consultationNew)
            info.data.consultationNew = { title: "فرم درخواست", description: "", sectionColor: { backGround: "", text: "" }, conform: false };
          if (!!info.data.pdfSelector && !info.data.pdfSelector.layout)
            info.data.pdfSelector = { ...info.data.pdfSelector, layout: "list" };

          // اختصاص نهایی به this.data
          let fixedData = this.fixVideoGallery(info.data);
          this.data = {
            ...fixedData,
            langs: {
              source_lang: this.defaultLang || info.data.langs.source_lang || "fa",
              other_langs: this.alllangs?.map((x) => ({ lang: x, status: "edited" })) || [],
            },
          };

          this.qrLink = data.data.link;
          this.res.language = this.defaultLang || getLanguageCookie() || "fa";

          let emitedData = { data: this.data, orders: this.orders, theme: this.theme, lang: this.data?.language };
          this.$root.$emit("visit-data-updated", { data: emitedData });
          this.setMainData({ data: emitedData });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    markQr(final = false) {
      this.loading = true;
      this.errors = {};

      let obj = {
        type: "visitcardpro",
        qrType: "dynamic",
        title: this.res.title,
        data: JSON.stringify({
          theme: this.theme,
          data: this.data,
        }),
        qr: {
          section: "#link", link: "https://qr2.in/", backcolor: "#ffffff", frontcolor: "#000000", gradient_color: "#000000", marker_out_color: "#000000", marker_in_color: "#000000", marker_top_right_outline: "#000000", marker_top_right_center: "#000000", marker_bottom_left_outline: "#000000", marker_bottom_left_center: "#000000", framecolor: "#000000", optionlogo: "none", "logo-size": 100, marker: "default", marker_in: "default", outer_frame: "none", framelabel: "SCAN ME", label_font: "AbrilFatface.svg", "label-text-size": 100, size: "248", level: "M",
        },
      };
      
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.data.language = this.defaultLang || getLanguageCookie() || "fa";

      this.$api
        .put(`qr/template/${this.id}`, {
          qr: obj,
          type: "visitcardpro",
          title: this.res.title,
        })
        .then(({ data }) => {
          this.finish = final;
          this.loading = false;
          this.$toast.success("کارت ویزیت شما با موفقیت ساخته شد.");
          this.$router.replace({ name: "modelsList" });
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
          this.loading = false;
        });
    },

    // saveToMainQr(data, final) {
    //   return this.$api
    //     .put("/v1/testQr/update", data, {
    //       headers: { "Content-Type": "application/x-www-form-urlencoded" },
    //     })
    //     .then(() => {
    //       this.$toast.success(this.$t("visit_card_edited_successfully"));
    //       if (final) this.goto("qr/list");
    //     })
    //     .catch((err) => this.handleError(err))
    //     .finally(() => {
    //       this.loading = false;
    //       this.goto("qr/list");
    //     });
    // },
    // saveToLangFtp(lang, final, content) {
    //   const allLangs_1 = [this.defaultLang || "fa", ...this.alllangs];

    //   return this.$api
    //     .post(`/v1/testQr/update-lang-data/${this.createQrID}`, {
    //       lang: lang,
    //       data: content,
    //       langs: allLangs_1,
    //     })
    //     .then(() => {
    //       this.$toast.success(this.$t("language.saved"));
    //       if (final) this.goto("qr/list");
    //     })
    //     .catch((err) => this.handleError(err))
    //     .finally(() => (this.loading = false));
    // },
  },
};
</script>
<style scoped>
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important; 
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}
</style>
